import { useNavigate } from 'react-router-dom';
import { Search, Menu, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSidebar } from '../../../context/SidebarContext';
import { useFavorites } from '../hooks/useFavorites';
import { FavoritesGrid } from '../components/FavoritesGrid';
import { Skeleton } from '@/components/ui/skeleton';

export function FavoritesPage() {
  const navigate = useNavigate();
  const { isCollapsed, toggle } = useSidebar();
  const { favorites, isLoading, reorder } = useFavorites();

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex-shrink-0 border-b border-border bg-card/50 backdrop-blur-sm">
        <div className="px-4 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={toggle}
              className={`h-11 w-11 flex-shrink-0 bg-gray-100 dark:bg-zinc-700 ${isCollapsed ? '' : 'invisible'}`}
              title="Open sidebar"
            >
              <Menu className="h-6 w-6" />
            </Button>
            <h1 className="text-lg font-semibold">Worktop</h1>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/a/arche_make_a_request')}
              className="gap-1.5 [&_svg]:size-5!"
            >
              <Search />
              Make a Re-Quest
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/a/arche_favorites/featured')}
              className="gap-1.5 [&_svg]:size-5!"
            >
              <Sparkles />
              Add Featured
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-4 sm:p-6">
        <div className="max-w-5xl mx-auto">
          {isLoading ? (
            <div className="grid grid-cols-5 lg:grid-cols-7 gap-x-3 sm:gap-x-6 gap-y-4 max-w-xl lg:max-w-3xl mx-auto">
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={i} className="flex flex-col items-center gap-2">
                  <Skeleton className="w-full aspect-square rounded-2xl" />
                  <Skeleton className="h-3 w-3/4 rounded" />
                </div>
              ))}
            </div>
          ) : (
            <FavoritesGrid favorites={favorites} onReorder={reorder} />
          )}
        </div>
      </div>
    </div>
  );
}
